import { ReactNode } from 'react';
import { BoxProps } from '@mui/material/Box';
import cn from 'classnames';
import { renderHTMLString } from '../../../../../helpers';

import { MuiBox } from '../../../../../modules/material';
import Heading, { HeadingProps } from '../Heading';
import Typography, { TypographyProps } from '../../library/Typography';
import { useRootSelector } from '../../../../../store/hooks';
import { selectPageConfig } from '../../../../../store/features/pageConfig';

export interface SectionHeaderProps extends BoxProps {
  heading: ReactNode;
  headingProps?: HeadingProps;
  description?: ReactNode;
  descriptionProps?: TypographyProps;
}

export default function SectionHeader(props: SectionHeaderProps) {
  const { heading, headingProps, description, descriptionProps, ...boxProps } =
    props;

  const { location } = useRootSelector(selectPageConfig);

  return (
    <MuiBox
      {...boxProps}
      className={cn(boxProps.className, 'informa-payment-header')}
    >
      <Heading
        variant="h2"
        gutterBottom={!!description}
        isUppercase
        {...headingProps}
        className={cn(headingProps?.className, 'informa-payment-header__title')}
      >
        {heading}
      </Heading>
      {description && (
        <Typography
          variant="body1"
          component="div"
          neutralColorIndex={700}
          {...descriptionProps}
          className={cn(
            headingProps?.className,
            'informa-payment-header__description',
          )}
        >
          {renderHTMLString(description, location)}
        </Typography>
      )}
    </MuiBox>
  );
}
